import styled from "styled-components";
import { PropsWithChildren, useEffect, useState } from "react";
import { DateTime } from "luxon";

// make the timercontainer span the entire width of the page
const TimerContainer = styled.section`
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 0px;
  z-index: 5;
  overflow: hidden;
  padding-top:10px;
  padding-bottom:0px;
  background-color: #0060df; 

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    padding-left: 10px;
  padding-right: 10px;
  padding-top:0px;
  padding-bottom:0px;
  }
  & > * {
    display: flex;
    flex-direction: column;
    margin: 0;
    justify-content: center;
  }
`;


const TimerContainerLanding = styled.section`
height:80px;
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 0px;
  z-index: 1000;
  overflow: hidden;
  padding-top:0px;
  padding-bottom:0px;
  background: linear-gradient(275.4deg, #074199 45.31%, #0B6DFF 59.75%);
  position: sticky;
  top: var(--referral-banner-height, 0px);

border-bottom: 4px solid #0558D4;
  display: flex;
     flex-direction: row;
    -webkit-box-pack: center;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
    align-items: center;
  @media (max-width: 768px) {
    display:block;
     padding-top:0px;
     height:70px;
     background: linear-gradient(355.76deg, #074199 3.91%, #0B6DFF 97.03%);
        display: flex
;
        justify-content: space-between;
        padding-left: 10px;
        padding-right: 10px;


  }
  & > * {
    display: flex;
    flex-direction: column;
    margin: 0;
    justify-content: center;
  }
`;


const TitleImage = styled.img`
  position: absolute;
  height: 100px;
  width: 100px;
  flex-shrink: 0;
  top: 0;
  left: -100px;
  filter: invert(1);
  @media (max-width: 865px) {
    display: none;
  }
`;

const TimerImage = styled.img`
  @media (min-width: 866px) {
    display: none;
  }
  position: absolute;
  height: 100px;
  width: 100px;
  flex-shrink: 0;
  top: -35;
  left: -10px;
  filter: invert(1);
  @media (max-width: 425px) {
    display: none;
  }
`;

const StyledTitle = styled.h1`
  position: relative;
  font-family: "Oswald";

  font-size: 32px;

  font-weight: 900;
  margin-top: 5px;
  color: #ffffff;
  text-transform: uppercase;
  text-align: center;
  max-width: 900px;
  text-shadow: 2px 2px 0px #1e1e1e;
  
  @media (max-width: 768px) {
    margin-top: 0px;

    font-size: 28px;

  }
`;

const TimerBody = styled.h3`
  font-family: 'Oswald';
  color: #f5f5f5;
  font-size: 24px;
  font-weight: 600;

  
  padding-top: 0px;
  padding-bottom: 0px;

  text-align: center;
  @media (max-width: 768px) {
    font-size:12px;
     padding-bottom: 10px;
  }
`;

const TimerBodyspan= styled.span`
text-decoration: underline;
`;

const MiniBody = styled.div`
  color: #f5f5f5;
  display: inline;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 18px;
  padding-bottom: 10px;
  text-align: center;

  font-style: italic;
`;

const MiniBodyBold = styled.div`
  color: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 18px;
  font-weight:600;
  padding-bottom: 10px;
  text-align: center;

`;

const MiniTitle = styled.div`
  position: relative;
  font-family: "Oswald";
  font-size: 28px;
  font-weight: 900;
  margin-top: 5px;
  color: #ffffff;
  text-transform: uppercase;
  text-align: center;
  max-width: 900px;
  text-shadow: 4px 4px 0px #1e1e1e;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const MiniImage = styled.img`
  position: absolute;
  flex-shrink: 0;
  top: 0;
  left: -50px;
  height: 50px;
  width: 50px;
  flex-shrink: 0;
  filter: invert(1);
  @media (max-width: 510px) {
    display: none;
  }
`;

const TimerCol = styled.div`
font-family: Oswald;
font-weight: 700;
font-style: Bold;
font-size: 24px;

line-height: 32px;
letter-spacing: 0px;


&span{
  font-size:10px; 
}
`;
const Timers = styled.div`
  position: relative;
  margin-top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  justify-items: center;
  @media (max-width: 510px) {
  margin-top: 0px;
  font-size:12px;
 gap: 5px;
  }
  ${TimerCol} {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    span {
     
      font-size: 24px;
      font-weight: 600;
      @media (max-width: 510px) {
       font-size: 12px;
       
      }
    }
  }
`;

const TimerBodyMobile=styled.div`
font-size:24px;
line-height:28px;
font-family:'Oswald';
font-weight:600;
color:white;
 @media (max-width: 510px) {
   font-size:12px;
   margin-top:5px;
   line-height:14px;
  }
`;
const Card = styled.div`
 
  padding-top: 10px;
  display: block;

  color: white;
  font-family: 'Oswald';
  
  font-feature-settings: "tnum";
  font-size: 24px;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 0px;
  @media (max-width: 510px) {
   font-size: 14px;
  }
`;

const HiddenWhenBig = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;

const TimersBody=styled.div`
    font-family: 'Oswald';
  color: #f5f5f5;
  font-size: 24px;
  font-weight: 600;

  
  padding-top: 0px;
  padding-bottom: 0px;

  text-align: center;
  @media (max-width: 768px) {
    font-size:12px;
     padding-bottom: 0px;
  }
`;

const TimerLeft=styled.div`
    display: flex
;
    flex-direction: row;
    padding: 0px;
    margin: 0px;
    flex-wrap: nowrap;
    align-items: center;
}
`;

const TimerLeftRow=styled.div`
display:flex;
margin-left:10px;
flex-direction:column;
`;

const TimerBlackFriday=styled.div`

font-family:'Oswald';
color:white;
font-weight:700;



font-size: 16px;

line-height: 24px;
letter-spacing: 0.4px;
@media only screen and (max-width: 600px) {

font-family: Oswald;
font-weight: 600;

font-size: 14px;

line-height: 14px;
letter-spacing: 0px;

}

`;

const TimersLeftIcon=styled.div`

svg{

}
@media only screen and (max-width: 600px) {
display:none;
}
`;

const TimersRight=styled.div`
    display: flex
;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;
    border: 1px solid;
    border-radius: 50px;
    padding: 2px 25px;
    gap: 15px;
    height: 60px;
    @media only screen and (max-width: 600px) {
    height:45px;
        padding: 2px 15px;
    gap: 10px;
    }

`;

const TimersRightNew=styled.div`
text-align: left;
font-family: 'Oswald';
font-weight: 500;

font-size: 14px;

line-height: 20px;
letter-spacing: 0.7px;
  @media only screen and (max-width: 600px) {
   font-size: 10px;
   line-height: 12px;
           display: flex;
        flex-direction: column;
        align-content: flex-start;
        align-items: flex-start;
        padding-top: 5px;
    }


`;

const getTimeLeft = (targetTime: Date) => {
  const now = new Date();
  const difference = targetTime.getTime() - now.getTime();
  if (difference <= 0) {
    return null;
  }

  const timeLeft = {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((difference / 1000 / 60) % 60),
    seconds: Math.floor((difference / 1000) % 60),
  };

  return timeLeft;
};


const formatTimeUnit = (unit: number) => unit.toString().padStart(2, '0');

type Props = PropsWithChildren<{mini?: boolean, extra?: string}>;
const BlackFridayTimer = (props: Props) => {
  const enabled = true;
  const [endTime, setEndTime] = useState(() => DateTime.now().plus({ minutes: 15 }).toJSDate());
  const [timeLeft, setTimeLeft] = useState(getTimeLeft(endTime));

  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTimeLeft = getTimeLeft(endTime);
      if (updatedTimeLeft) {
        setTimeLeft(updatedTimeLeft);
      } else {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime, timeLeft]);

  if (!enabled) {
    return <></>;
  }

  if (!timeLeft) {
    return <></>;
  }

  /*
  if (props.mini) {
    return (<TimerContainer>
      <>
      <MiniBodyBold>
      Get Up To 20% Off Your All-New BWS+ Program
      </MiniBodyBold>
      <MiniBody>

      Risk-Free 14 Day Free Trial
</MiniBody>
      </>

    </TimerContainer>);
  }
  */
  if (props.mini) {
    return (<></>);
  }  

  return (

    <TimerContainerLanding>
  <TimerLeft>
    
      <TimersLeftIcon>
<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="white" fill-opacity="0.1"/>
<path d="M32 20H16C15.4477 20 15 20.4477 15 21V23C15 23.5523 15.4477 24 16 24H32C32.5523 24 33 23.5523 33 23V21C33 20.4477 32.5523 20 32 20Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M24 20V33" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M31 24V31C31 31.5304 30.7893 32.0391 30.4142 32.4142C30.0391 32.7893 29.5304 33 29 33H19C18.4696 33 17.9609 32.7893 17.5858 32.4142C17.2107 32.0391 17 31.5304 17 31V24" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.5 19.9999C18.837 19.9999 18.2011 19.7366 17.7322 19.2677C17.2634 18.7989 17 18.163 17 17.4999C17 16.8369 17.2634 16.201 17.7322 15.7322C18.2011 15.2633 18.837 14.9999 19.5 14.9999C20.4647 14.9831 21.41 15.4512 22.2127 16.3431C23.0154 17.235 23.6383 18.5094 24 19.9999C24.3617 18.5094 24.9846 17.235 25.7873 16.3431C26.59 15.4512 27.5353 14.9831 28.5 14.9999C29.163 14.9999 29.7989 15.2633 30.2678 15.7322C30.7366 16.201 31 16.8369 31 17.4999C31 18.163 30.7366 18.7989 30.2678 19.2677C29.7989 19.7366 29.163 19.9999 28.5 19.9999" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</TimersLeftIcon>
 <TimerLeftRow>
   
 <TimerBlackFriday>Limited-Time Sale:</TimerBlackFriday>
<TimerBodyMobile>Get 20% Off + Exclusive Bonus Pack</TimerBodyMobile> 
     </TimerLeftRow>


 </TimerLeft>
<TimersBody>
<TimersRight>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.99604">
<path d="M12 6V12L16 14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
<TimersRightNew>
  OFFER ENDS IN
        <Timers>
           
         
          <TimerCol><Card>{formatTimeUnit(timeLeft.minutes)}</Card><span>m</span></TimerCol>
         <TimerCol><Card>{formatTimeUnit(timeLeft.seconds)}</Card><span>s</span></TimerCol>
        </Timers>
    </TimersRightNew>
    </TimersRight>
     </TimersBody>
   
    </TimerContainerLanding>
  );
};

export {
    BlackFridayTimer,
};
